// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "*[data-v-36fde2b4] .el-dialog__header{padding:20px 20px 71px}*[data-v-36fde2b4] .el-dialog__body{padding:0}", ""]);
// Exports
module.exports = exports;
